import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from './styles.module.scss';

interface SectionProps {
  className?: string;
  children: ReactNode;
}

export const Section = ({ className, children }: SectionProps) => {
  return (
    <section className={classNames(styles.section, className)}>
      {children}
    </section>
  );
};
